module.exports = __webpack_public_path__ + "static/media/gimp.0cd0bc06.svg";